export function renderLanding(app: HTMLElement): void {
  app.innerHTML = `
    <section class="hero">
      <div class="container hero-grid">
        <div class="hero-copy">
          <span class="hero-badge">Agile, simplified</span>
          <h1>Plan, track and ship projects with total clarity.</h1>
          <p class="hero-sub">
            FlowBoard replaces your spreadsheets with a beautiful workspace for stories,
            story points, sprint boards and real-time reporting — for every project you
            run, personal or professional.
          </p>
          <div class="hero-actions">
            <a class="btn btn-primary btn-lg" href="#/signup">Start for free</a>
            <a class="btn btn-ghost btn-lg" href="#/login">Sign in</a>
            <a class="btn btn-ghost btn-lg" href="#/public">Browse public projects</a>
          </div>
          <div class="hero-points">
            <span>No credit card required</span>
            <span>Unlimited projects</span>
            <span>Private by default</span>
          </div>
        </div>
        <div class="hero-visual">
          <div class="mini-board">
            <div class="mini-col">
              <div class="mini-col-head">To do <span>3</span></div>
              <div class="mini-card">Design signup flow <span class="mini-pts">5 pts</span></div>
              <div class="mini-card">Plan launch checklist <span class="mini-pts">3 pts</span></div>
            </div>
            <div class="mini-col">
              <div class="mini-col-head">In progress <span>2</span></div>
              <div class="mini-card">Build sprint board <span class="mini-pts">8 pts</span></div>
            </div>
            <div class="mini-col">
              <div class="mini-col-head">Done <span>4</span></div>
              <div class="mini-card">Account setup <span class="mini-pts">5 pts</span></div>
              <div class="mini-card">Landing page <span class="mini-pts">3 pts</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="features">
      <div class="container">
        <div class="section-head">
          <h2>Everything your team needs, in one place</h2>
          <p>Stop juggling Excel files. FlowBoard tracks the work, the people and the points automatically.</p>
        </div>
        <div class="feature-grid">
          <div class="feature-card">
            <div class="feature-icon">🗂️</div>
            <h3>Unlimited projects</h3>
            <p>Create a project for anything — client work, side projects or shared goals — with a clear name and description.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🧑‍🤝‍🧑</div>
            <h3>Project members</h3>
            <p>Add the people involved in seconds. Assign stories to anyone and see exactly who is doing what.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">🎯</div>
            <h3>Story points</h3>
            <p>Estimate every story with story points so effort is measurable, not a guess.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📋</div>
            <h3>Sprint board</h3>
            <p>Drag tasks across Not Started, Started, In Progress, Blocked and Complete — or switch status in the list view.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">✍️</div>
            <h3>Rich markdown stories</h3>
            <p>Write detailed descriptions in Markdown. Click any task to see a beautifully rendered view.</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">📊</div>
            <h3>Automatic reporting</h3>
            <p>See who completed how many points — over the last week, month, three months or the whole project.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section" id="how-it-works" style="background:#fff;border-top:1px solid var(--border);border-bottom:1px solid var(--border);">
      <div class="container">
        <div class="section-head">
          <h2>Up and running in three steps</h2>
          <p>No onboarding call, no configuration maze. Just create, invite and track.</p>
        </div>
        <div class="steps">
          <div class="step">
            <div class="step-num">1</div>
            <h3>Create a project</h3>
            <p>Give it a name and describe what it's about.</p>
          </div>
          <div class="step">
            <div class="step-num">2</div>
            <h3>Add your people</h3>
            <p>Add project members with a simple name each.</p>
          </div>
          <div class="step">
            <div class="step-num">3</div>
            <h3>Track &amp; report</h3>
            <p>Create stories, assign points and watch progress update itself.</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="cta-band">
          <h2>Ready to leave the spreadsheet behind?</h2>
          <p>Create your free account and manage every project you care about in one beautiful place.</p>
          <a class="btn btn-lg" href="#/signup">Get started — it's free</a>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="container">
        FlowBoard · Agile project management for modern teams.
      </div>
    </footer>
  `;
}
